import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logoutUser } from '../services/userService';
import NotificationBell from './NotificationBell';
const Navbar = ({ user, userData }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showUserTypeModal, setShowUserTypeModal] = useState(false);
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      const result = await logoutUser();
      if (result.success) {
        navigate('/login');
      } else {
        console.error('Logout failed:', result.error);
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  };
  const handleUserTypeSelection = (userType) => {
    setShowUserTypeModal(false);
    navigate(`/register?type=${userType}`);
  };
  return (
    <>
      <nav className="mx-auto my-3 max-w-7xl rounded-2xl border border-slate-200/60 bg-white/95 backdrop-blur-md sticky top-3 z-50 shadow-md transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Brand Logo */}
            <div className="flex items-center">
              <Link to={user ? "/dashboard" : "/"} className="flex items-center group">
                <div className="flex items-center gap-2 px-2 py-1.5 rounded-xl bg-white/50 backdrop-blur-sm border border-blue-50 hover:border-blue-200 transition-all duration-300">
                  <div className="w-9 h-9 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-100 overflow-hidden">
                    <img src="/log1.png" alt="Harshal Jobs Logo" className="w-full h-full object-contain bg-white p-1" />
                  </div>
                  <div className="flex flex-col -gap-1">
                    <h1 className="text-lg font-black text-[#0f172a] tracking-tighter leading-none">Harshal<span className="text-blue-600">Jobs</span></h1>
                    <p className="text-[8px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">Career Intelligence</p>
                  </div>
                </div>
              </Link>
            </div>
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-1">
              {user ? (
                <>
                  {/* Navigation Links */}
                  <div className="flex items-center space-x-1">
                    <Link
                      to="/dashboard"
                      className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                      </svg>
                      <span className="hidden lg:inline">Console</span>
                    </Link>
                    {(userData?.userType === 'superadmin') && (
                      <Link
                        to="/superadmin/companies"
                        className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                        <span className="hidden lg:inline">Enterprises</span>
                      </Link>
                    )}
                    {(userData?.userType === 'employer' || userData?.userType === 'superadmin') && (
                      <Link
                        to="/database"
                        className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span className="hidden lg:inline">Candidates</span>
                      </Link>
                    )}
                    <Link
                      to={userData?.userType === 'superadmin' ? '/superadmin/packages' : '/packages'}
                      className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                      </svg>
                      <span className="hidden lg:inline">Subscription Models</span>
                    </Link>
                    {userData?.userType === 'superadmin' && (
                      <Link
                        to="/superadmin/marketing-package"
                        className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                        </svg>
                        <span className="hidden lg:inline">Campaign Banners</span>
                      </Link>
                    )}

                    {userData?.userType === 'franchise' && (
                      <>
                        <Link
                          to="/franchise/profile"
                          className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                          <span className="hidden lg:inline">Profile</span>
                        </Link>
                        <Link
                          to="/franchise/users"
                          className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                          </svg>
                          <span className="hidden lg:inline">Users</span>
                        </Link>
                        <Link
                          to="/franchise/companies"
                          className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                          </svg>
                          <span className="hidden lg:inline">Companies</span>
                        </Link>
                        <Link
                          to="/franchise/jobs"
                          className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                          <span className="hidden lg:inline">Jobs</span>
                        </Link>
                      </>
                    )}

                    {userData?.userType === 'employer' && (
                      <Link
                        to="/billing-history"
                        className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-650 hover:text-blue-600 hover:bg-slate-50 text-sm font-semibold transition-all duration-200"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <span className="hidden lg:inline">Billing Ledger</span>
                      </Link>
                    )}
                    {/* Notification Bell */}
                    <div className="relative">
                      <NotificationBell user={user} />
                    </div>
                    {/* Combined User Profile & Logout */}
                    <div className="relative group">
                      <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-slate-900 to-slate-800 hover:from-slate-800 hover:to-slate-700 text-white rounded-xl text-sm font-medium border border-slate-700 shadow-md shadow-slate-900/10 hover:shadow-lg transition-all duration-200"
                      >
                        <div className="relative">
                          <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                            <span className="text-white font-bold text-sm">{userData?.firstName?.charAt(0)?.toUpperCase()}</span>
                          </div>
                          <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                        </div>
                        <div className="flex flex-col items-start text-left">
                          <span className="text-sm font-semibold">{userData?.firstName}</span>
                          <span className="text-[10px] opacity-80">{userData?.userType === 'jobseeker' ? 'Candidate' : userData?.userType === 'superadmin' ? 'Super Admin' : userData?.userType === 'franchise' ? 'Franchise' : 'Employer'}</span>
                        </div>
                        <span className="text-xs font-semibold pl-2 border-l border-white/20 hover:text-red-300 transition-colors">Sign Out</span>
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="flex items-center space-x-4">
                  <Link
                    to="/login"
                    className="px-4 py-2 text-slate-700 hover:text-slate-900 font-semibold text-sm transition-all duration-200 hover:scale-105"
                  >
                    Access Account
                  </Link>
                  <button
                    onClick={() => setShowUserTypeModal(true)}
                    className="px-5 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-full text-sm font-semibold shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 transform"
                  >
                    Initialize Session
                  </button>
                </div>
              )}
            </div>
            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2 rounded-lg text-blue-600 hover:text-blue-800 hover:bg-blue-50 transition-all duration-200"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>
          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden">
              <div className="px-4 pt-4 pb-6 space-y-4 bg-white border-t border-slate-200">
                {user ? (
                  <>
                    {/* User Profile */}
                    <div className="flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-slate-50 to-slate-100 rounded-xl border border-slate-200">
                      <div className="relative">
                        <div className="w-12 h-12 bg-gradient-to-br from-slate-400 to-slate-500 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg">
                          {userData?.firstName?.charAt(0)?.toUpperCase()}
                        </div>
                        <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-blue-500 rounded-full border-2 border-white"></div>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-sm font-semibold text-slate-800">
                          {userData?.firstName} {userData?.lastName}
                        </span>
                        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${userData?.userType === 'superadmin'
                          ? 'bg-slate-600 text-white'
                          : 'bg-slate-200 text-slate-700'
                          }`}>
                          {userData?.userType === 'jobseeker' ? 'Job Seeker' : userData?.userType === 'superadmin' ? 'Super Admin' : userData?.userType === 'franchise' ? 'Franchise' : 'Employer'}
                        </span>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <Link
                        to="/dashboard"
                        className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                          <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2v0a2 2 0 012-2h6l2 2h6a2 2 0 012 2v1" />
                          </svg>
                        </div>
                        Console
                      </Link>
                      {/* Show Companies only for superadmin and jobseeker */}
                      {(userData?.userType === 'superadmin') && (
                        <Link
                          to="/superadmin/companies"
                          className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                            <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                          </div>
                          Enterprises
                        </Link>
                      )}
                      {(userData?.userType === 'employer' || userData?.userType === 'superadmin') && (
                        <Link
                          to="/database"
                          className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                            <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                          </div>
                          Candidates
                        </Link>
                      )}
                      <Link
                        to={userData?.userType === 'superadmin' ? '/superadmin/packages' : '/packages'}
                        className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                          <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                          </svg>
                        </div>
                        Subscription Models
                      </Link>
                      {userData?.userType === 'superadmin' && (
                        <Link
                          to="/superadmin/marketing-package"
                          className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                            <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                            </svg>
                          </div>
                          Campaign Banners
                        </Link>
                      )}

                      {userData?.userType === 'franchise' && (
                        <>
                          <Link
                            to="/franchise/profile"
                            className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                              <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                              </svg>
                            </div>
                            Profile
                          </Link>
                          <Link
                            to="/franchise/users"
                            className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                              <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                              </svg>
                            </div>
                            Users
                          </Link>
                          <Link
                            to="/franchise/companies"
                            className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                              <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                              </svg>
                            </div>
                            Companies
                          </Link>
                          <Link
                            to="/franchise/jobs"
                            className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                              <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                              </svg>
                            </div>
                            Jobs
                          </Link>
                        </>
                      )}

                      {userData?.userType === 'employer' && (
                        <Link
                          to="/billing-history"
                          className="flex items-center gap-3 text-slate-600 hover:text-slate-800 hover:bg-slate-100 px-4 py-3 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-sm border border-transparent hover:border-slate-300"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          <div className="w-8 h-8 bg-slate-100 rounded-lg flex items-center justify-center">
                            <svg className="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </div>
                          Billing Ledger
                        </Link>
                      )}
                      {/* Mobile Notification Bell */}
                      <div className="flex items-center justify-center py-2">
                        <NotificationBell user={user} />
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        handleLogout();
                        setIsMenuOpen(false);
                      }}
                      className="flex items-center gap-3 w-full text-left bg-slate-900 hover:bg-slate-800 text-white px-4 py-3 rounded-lg text-base font-semibold shadow-sm hover:shadow-md transition-all duration-300 mt-4 border border-slate-700"
                    >
                      <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                      </div>
                      Sign Out
                    </button>
                  </>
                ) : (
                  <div className="space-y-3">
                    <Link
                      to="/login"
                      className="flex items-center gap-3 text-slate-700 hover:text-blue-600 hover:bg-gradient-to-r hover:from-blue-50/50 hover:to-indigo-50/50 px-4 py-3 rounded-xl text-base font-semibold transition-all duration-300 hover:shadow-md hover:scale-[1.02] border border-transparent hover:border-blue-200/30"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                        <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                      </div>
                      Access Account
                    </Link>
                    <button
                      onClick={() => {
                        setIsMenuOpen(false);
                        setShowUserTypeModal(true);
                      }}
                      className="flex items-center gap-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-4 py-3 rounded-xl text-base font-semibold w-full shadow-md hover:shadow-lg transition-all duration-300"
                    >
                      <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                        </svg>
                      </div>
                      Initialize Session
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </nav>
      {/* User Type Selection Modal - Outside nav for proper positioning */}
      {showUserTypeModal && (
        <>
          {/* Modal Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
            onClick={() => setShowUserTypeModal(false)}
          ></div>
          {/* Modal Content */}
          <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 pointer-events-none">
            <div
              className="bg-white rounded-lg shadow-lg max-w-md w-full p-8 transform transition-all duration-300 scale-100 opacity-100 pointer-events-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="text-center mb-6">
                <div className="mx-auto w-16 h-16 rounded-lg overflow-hidden shadow-lg mb-4 ring-2 ring-slate-200">
                  <img
                    src="/harshal_jobs.png"
                    alt="Harshal Jobs Logo"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="w-full h-full bg-slate-400 flex items-center justify-center" style={{ display: 'none' }}>
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Initialize Your Profile Session</h2>
                <p className="text-gray-600">Select your operational mode to begin matching</p>
              </div>
              <div className="space-y-4">
                {/* Job Seeker Option */}
                <button
                  onClick={() => handleUserTypeSelection('jobseeker')}
                  className="w-full p-6 border-2 border-slate-200 rounded-lg hover:border-slate-400 hover:bg-slate-50 transition-all duration-200 group text-left"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center group-hover:bg-slate-200 transition-colors">
                      <svg className="w-6 h-6 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 group-hover:text-slate-700">I am a Candidate / Job Seeker</h3>
                      <p className="text-gray-600 text-sm">Search high-caliber postings and accelerate career trajectory</p>
                    </div>
                    <svg className="w-5 h-5 text-slate-400 group-hover:text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </button>
                {/* Employer Option */}
                <button
                  onClick={() => handleUserTypeSelection('employer')}
                  className="w-full p-6 border-2 border-slate-200 rounded-lg hover:border-slate-400 hover:bg-slate-50 transition-all duration-200 group text-left"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center group-hover:bg-slate-200 transition-colors">
                      <svg className="w-6 h-6 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 group-hover:text-slate-700">I am a Hiring Manager / Employer</h3>
                      <p className="text-gray-600 text-sm">Publish requisitions and source premier industry professionals</p>
                    </div>
                    <svg className="w-5 h-5 text-slate-400 group-hover:text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </button>
              </div>
              {/* Close Button */}
              <div className="mt-6 text-center">
                <button
                  onClick={() => setShowUserTypeModal(false)}
                  className="text-slate-500 hover:text-slate-700 font-medium transition-colors duration-200 hover:underline"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Navbar;
